import { Box, Typography } from "@mui/material";

import fontWeight from "../../styles/mui/fontWeight";
import { colors } from "../../styles/colors";
import { Asterisk, ReadOnlyFieldContainer, ReadOnlyFieldIcon, ReadOnlyFieldLabel, ReadOnlyFieldValue } from "../styles/styles";
import { fontSize } from "../../styles/mui/styles/font";

type ReadOnlyFieldProps = {
  label?: string;
  value: string | number;
  icon?: any;
  mandatorySymbol?: boolean;
  borderBottom?: boolean;
  isReauthAgency?: boolean;
  CssValue?: object;
};

const ReadOnlyField = (props: ReadOnlyFieldProps) => {
  const { label, value, icon, mandatorySymbol, borderBottom } = props;
  return (
    <Box sx={ReadOnlyFieldContainer(borderBottom)}>
      <Box sx={ReadOnlyFieldLabel}>
    <Typography fontWeight={fontWeight[3]} fontSize={fontSize[11]} color={colors.fonts[2]}>
          {label}
        </Typography>
        {mandatorySymbol && (
          <Typography
            variant="subtitle2"
            color={colors.red[103]}
            fontWeight={fontWeight[2]}
            pr={2}
            sx={Asterisk}
          >
            *
          </Typography>
        )}
      </Box>
      <Box
        sx={
          props.CssValue
            ? { ...ReadOnlyFieldValue(), ...props.CssValue }
            : ReadOnlyFieldValue()
        }
        pt={1}
      >
        {icon && <Box sx={ReadOnlyFieldIcon}>{icon}</Box>}
        <Box color={colors.black[5]}>
          {!props.isReauthAgency && (
            <Typography fontWeight={fontWeight[4]} fontSize={fontSize[13]} lineHeight="1.3">
              {value || ""}
            </Typography>
          )}

          {props.isReauthAgency && (
            <>
              <Typography fontWeight={fontWeight[4]} fontSize={fontSize[13]} lineHeight="1.3" pt={"0.8rem"}>
                {String(value).split("\n")[0] ?? ""}
              </Typography>

              {String(value).includes("\n") && (
                <Typography fontWeight={fontWeight[4]} fontSize={fontSize[13]} lineHeight="1.3">
                  {String(value).split("\n")[1] ?? ""}
                </Typography>
              )}
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default ReadOnlyField;
